export default __webpack_public_path__ + "static/tile-featured-2-859f15b8d7164c956d6ed954dc44ee0b.jpg";